export function brandDomainLabel(canonicalUrl) {
    const domain = canonicalUrl.replace(/^https?:\/\//, '');
    return domain.charAt(0).toUpperCase() + domain.slice(1);
}
/** Brands opting into legalCopyUsesBrandDomain reuse the flush legal copy (which carries a
 * [BRAND_DOMAIN] placeholder) with their own canonicalUrl filled in, instead of duplicating
 * the paragraph per brand/locale. */
export function resolveFooterLegalText(params) {
    const { useFlushLegalCopy, flushLegalTemplate, defaultLegalText, canonicalUrl } = params;
    if (!useFlushLegalCopy)
        return defaultLegalText;
    return flushLegalTemplate.replaceAll('[BRAND_DOMAIN]', brandDomainLabel(canonicalUrl));
}
